module.exports = __webpack_public_path__ + "522fa9a4aa056d17f717c2e5d1a1af5d.otf";